import { EnumAutomationSchedulePreset } from '../enums/automation-schedule-preset.enum';
import { IAutomationScheduleRequest } from '../interfaces/automation.interface';

const DAY_OF_WEEK_NAMES = [
  'domingo',
  'segunda-feira',
  'terça-feira',
  'quarta-feira',
  'quinta-feira',
  'sexta-feira',
  'sábado',
];

const DAY_OF_WEEK_SHORT = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

const WEEKDAYS = [1, 2, 3, 4, 5];

export interface IAutomationScheduleForm {
  preset: EnumAutomationSchedulePreset;
  daysOfWeek: number[];
  dayOfMonth: number;
  time: string;
}

const ordinalDayOfMonth = (day: number): string =>
  day === 1 ? 'todo dia 1º' : `todo dia ${day}`;

export const humanizeSchedule = (schedule: IAutomationScheduleForm): string => {
  const time = schedule.time || '00:00';
  const days = schedule.daysOfWeek;

  if (schedule.preset === EnumAutomationSchedulePreset.Daily) {
    if (days.length === 5 && WEEKDAYS.every(day => days.includes(day))) {
      return `Nos dias úteis às ${time}`;
    }
    if (days.length === 7 || days.length === 0) {
      return `Todos os dias às ${time}`;
    }
    const names = [...days].sort().map(day => DAY_OF_WEEK_SHORT[day]).join(', ');
    return `Toda semana (${names}) às ${time}`;
  }

  if (schedule.preset === EnumAutomationSchedulePreset.Weekly) {
    if (!days.length) {
      return `Semanalmente às ${time}`;
    }
    if (days.length === 1) {
      return `Toda ${DAY_OF_WEEK_NAMES[days[0]]} às ${time}`;
    }
    const names = [...days].sort().map(day => DAY_OF_WEEK_SHORT[day]).join(', ');
    return `Toda semana (${names}) às ${time}`;
  }

  const ordinal = ordinalDayOfMonth(schedule.dayOfMonth);
  return `${ordinal.charAt(0).toUpperCase()}${ordinal.slice(1)} às ${time}`;
};

export const buildScheduleRequest = (
  schedule: IAutomationScheduleForm,
  timezone: string,
): IAutomationScheduleRequest => {
  if (schedule.preset === EnumAutomationSchedulePreset.Daily) {
    const isEveryDay = schedule.daysOfWeek.length === 7;
    return {
      preset: EnumAutomationSchedulePreset.Daily,
      daysOfWeek: isEveryDay ? [] : [...schedule.daysOfWeek].sort(),
      time: schedule.time,
      timezone,
    };
  }

  if (schedule.preset === EnumAutomationSchedulePreset.Weekly) {
    return {
      preset: EnumAutomationSchedulePreset.Weekly,
      dayOfWeek: schedule.daysOfWeek[0] ?? 1,
      time: schedule.time,
      timezone,
    };
  }

  return {
    preset: EnumAutomationSchedulePreset.Monthly,
    dayOfMonth: schedule.dayOfMonth,
    time: schedule.time,
    timezone,
  };
};
